import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import HomeIcon from '@material-ui/icons/Home'
import { productIcon } from 'helpers'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import { appBar, primaryColor } from '../Styles'
const SamplingsByProductScreen = props => {
  const data = props.selectedSamplingProduct

  const rgb2hex = (red, green, primaryColor) => {
    const rgb = primaryColor | (green << 8) | (red << 16)
    return '#' + (0x1000000 + rgb).toString(16).slice(1)
  }

  const getColor = (i, length) => {
    const startColor = [0, 200, 52]
    const endColor = [219, 95, 25]
    const numIntermediateColor = length - 2

    if (i === 0) {
      return rgb2hex(startColor[0], startColor[1], startColor[2])
    } else if (i === length - 1) {
      return rgb2hex(endColor[0], endColor[1], endColor[2])
    } else {
      const r = startColor[0] + ((endColor[0] - startColor[0]) * i) / numIntermediateColor
      const g = startColor[1] + ((endColor[1] - startColor[1]) * i) / numIntermediateColor
      const b = startColor[2] + ((endColor[2] - startColor[2]) * i) / numIntermediateColor

      return rgb2hex(r, g, b)
    }
  }

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Clasificaciones</Typography>
          </div>
          <div className='right' >
            <HomeIcon onClick={() => props.goTo('home', {})} className={props.classes.goBackIcon} />
          </div>
        </Toolbar>
      )}>
      <div className={props.classes.resume}>
        <Grid container spacing={16} alignItems="center">
          <Grid item xs={3}>
            <img alt="" src={productIcon(data.productIconFileName)} className={props.classes.productIcon} />
          </Grid>
          <Grid item xs={8}>
            <div>
              <Grid container alignItems="flex-end">
                <Grid item xs={7}>
                  <Typography className={props.classes.productName}>{data.productType}</Typography>
                </Grid>
                <Grid item xs={5}>
                  <div className={props.classes.sampledLabelContainer}>
                    <Typography className={props.classes.sampledLabel}>Clasificado</Typography>
                  </div>
                </Grid>
              </Grid>
              <div className={props.classes.sampledTotals}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography className={props.classes.sampledTotalLeft}>
                      {data.kgSampledTotal.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg.
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className={props.classes.sampledTotalRight}>
                      {data.eurosSampledTotal.toLocaleString(undefined, { maximumFractionDigits: 2 })} €
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <div style={{ marginTop: 10 }}>
                <Grid container alignItems="center">
                  <Grid item xs={data.averagePrice > 0 ? 6 : 12}>
                    <Typography className={props.classes.sampledPendingKgLabel}>Pendiente clasificar</Typography>
                    <Typography className={props.classes.sampledPendingKgValue}>
                      {data.kgPendingTotal.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg.
                    </Typography>
                  </Grid>
                  {data.averagePrice > 0 && (
                    <Grid item xs={6}>
                      <div className={props.classes.averagePriceContainer}>
                        <Typography className={props.classes.averagePriceLabel}>Precio medio</Typography>
                        <Typography className={props.classes.averagePriceValue}>
                          {data.averagePrice.toLocaleString(undefined, { maximumFractionDigits: 2 })} €
                        </Typography>
                      </div>
                    </Grid>
                  )}
                </Grid>
              </div>
              <div className={props.classes.filters}>
                <Typography className={props.classes.filtersText}>
                  Periodo:{' '}
                  <b
                    className={props.classes.primaryColor}
                    dangerouslySetInnerHTML={{
                      __html: props.periodLabelSimple,
                    }}
                  />
                  &nbsp;&nbsp;Naves:{' '}
                  <b className={props.classes.primaryColor}>
                    {props.selectedGreenhouses.length ? `${props.greenhouses.length} seleccionadas` : 'Todas'}
                  </b>
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={props.classes.samplings}>
        <div className={props.classes.rows}>
          {!data.samplings.length && <Typography style={{ marginBottom: 15 }}>Sin clasificaciones</Typography>}
          {data.samplings.map((sampling, i, samplings) => {
            return (
              <div key={'samp' + sampling.id} className={props.classes.row}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography className={props.classes.barPercentage}>
                      {sampling.percentage.toLocaleString(undefined, { maximumFractionDigits: 2 })}%
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <div
                      className={props.classes.bar}
                      style={{
                        width: `${sampling.percentage / 2}vw`,
                        backgroundColor: getColor(i, samplings.length),
                      }}
                    />
                    <div className={props.classes.barInfo}>
                      <Typography className={props.classes.barPrice}>
                        {sampling.price > 0 && (
                          <b>{sampling.price.toLocaleString(undefined, { maximumFractionDigits: 2 })} €&nbsp;</b>
                        )}
                        ({sampling.caliberName})
                      </Typography>
                      <Typography className={props.classes.barKg}>
                        {sampling.kg.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg.
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </div>
            )
          })}
        </div>
        <div className={props.classes.btEntriesContainer}>
          <div
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.keyCode === 83) props.goTo('samplings')
            }}
            onClick={() => props.onSelectEntryProduct(data.productType)}>
            <Typography className={props.classes.btEntries}>
              Ver entradas
              <KeyboardArrowRightIcon className={props.classes.btEntriesIcon} />
            </Typography>
          </div>
        </div>
      </div>
    </Page>
  )
}

const styles = {
  primaryColor: {
    color: primaryColor,
    fontWeight: 400,
  },
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  resume: {
    background: 'white',
    padding: '10px 10px 5px',
  },
  productIcon: {
    maxWidth: '100%',
  },
  productName: {
    marginBottom: 5,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '14px',
    color: primaryColor,
  },
  sampledLabelContainer: {
    textAlign: 'center',
  },
  sampledLabel: {
    display: 'inline-block',
    background: primaryColor,
    color: 'white',
    fontSize: 13,
    padding: '1px 6px',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
  },
  sampledTotals: {
    border: '1px solid ' + primaryColor,
    padding: '3px 5px',
    borderRadius: 5,
  },
  sampledTotalLeft: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '16px',
    color: primaryColor,
    borderRight: '1px solid ' + primaryColor,
    textAlign: 'center',
  },
  sampledTotalRight: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '16px',
    color: primaryColor,
    textAlign: 'center',
  },
  sampledPendingKgLabel: {
    color: primaryColor,
    fontSize: 14,
    textAlign: 'center',
    lineHeight: '15px',
  },
  sampledPendingKgValue: {
    color: primaryColor,
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  averagePriceContainer: {
    background: '#8ACA4C',
    borderRadius: 5,
    padding: 4,
  },
  averagePriceLabel: {
    color: 'white',
    textAlign: 'center',
    marginBottom: 3,
  },
  averagePriceValue: {
    background: 'white',
    borderRadius: 5,
    textAlign: 'center',
    fontSize: 22,
    fontWeight: 400,
  },
  filters: {
    marginTop: 10,
    borderTop: '1px solid #DDD',
    paddingTop: 3,
  },
  filtersText: {
    fontWeight: 300,
    fontSize: 12,
    color: '#53535',
  },
  samplings: {
    backgroundColor: '#EBEBEB',
  },
  rows: {
    padding: 10,
  },
  row: {
    marginBottom: 10,
  },
  barPercentage: {
    textAlign: 'right',
    paddingRight: 10,
  },
  bar: {
    display: 'inline-block',
    height: 30,
    borderRadius: 3,
    verticalAlign: 'middle',
  },
  barInfo: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginLeft: 10,
  },
  barPrice: {
    lineHeight: '17px',
  },
  barKg: {
    lineHeight: '17px',
  },
  btEntriesContainer: {
    padding: '0 15px 15px',
  },
  btEntries: {
    position: 'relative',
    padding: 5,
    fontSize: 16,
    backgroundColor: primaryColor,
    color: 'white',
    borderRadius: 3,
    textAlign: 'center',
    cursor: 'pointer',
  },
  btEntriesIcon: {
    position: 'absolute',
    top: 5,
    right: 0,
    color: 'white',
  },
}

export default withStyles(styles)(SamplingsByProductScreen)



// WEBPACK FOOTER //
// ./src/screens/SamplingsByProductScreen.js